// DO NOT EDIT THIS FILE BECAUSE IT IS GENERATED AUTOMATICALLY
import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVG = styled.svg.withConfig({
  componentId: "sc-15jqb2r-0"
})(["min-width:", ";max-width:", ";height:", ";"], _ref => {
  let {
    $size
  } = _ref;
  return $size;
}, _ref2 => {
  let {
    $size
  } = _ref2;
  return $size;
}, _ref3 => {
  let {
    $size
  } = _ref3;
  return $size;
});
const ChevronLeft = _ref4 => {
  let {
    size = "1em",
    color = "currentColor",
    title,
    ...props
  } = _ref4;
  return /*#__PURE__*/_jsxs(SVG, {
    ...props,
    $size: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: title ? 'img' : 'presentation',
    children: [title ? /*#__PURE__*/_jsx("title", {
      children: title
    }) : null, " ", /*#__PURE__*/_jsx("path", {
      fill: color,
      d: "M7.777 11.462a.75.75 0 0 0 0 1.076l5.4 5.25a.75.75 0 0 0 1.046-1.076L9.365 12.01l4.858-4.722a.75.75 0 0 0-1.046-1.076l-5.4 5.25z",
      children: " "
    })]
  });
};
ChevronLeft.propTypes = {
  /** The width/height of the icon as any CSS size unit */
  size: PropTypes.string,
  /** The fill color of the icon as any CSS color value */
  color: PropTypes.string,
  /** The title to add as a child of the root svg element */
  title: PropTypes.string
};
export default ChevronLeft;